import React, { Fragment, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Button, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import Message from "../../CommonData/Data/Message.js";
import {
  clearSubmitApprovalActionError,
  setApprovalsForm,
  submitApprovalAction
} from "../../store/approvals/actions.js";
import VWLoading from "../../components/vwLoading/vwLoading.js";


const ApprovalAction = (props) => {
  const { approvalsForm, action, errorMessage, handleClose, isPending } = props;
  const { comments } = approvalsForm || {};
  const textareaRef = useRef(null);

  useEffect(() => {
    props.setApprovalsForm({
      errors: {}
    })
    props.clearSubmitApprovalActionError();
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    props.setApprovalsForm(
      {
        ...approvalsForm,
        [name]: value,
        errors: {
          ...approvalsForm.errors,
          [name]: null,
        }
      })

    autoResize();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      props.setApprovalsForm(
        {
          ...approvalsForm,
          comments: (approvalsForm && approvalsForm.comments) ? approvalsForm.comments + "\n" : "\n",
          errors: {
            ...approvalsForm.errors,
            comments: null,
          }
        })
      autoResize();
    }
  };

  const autoResize = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { action, requestId } = props;
    const { comments } = approvalsForm || {};
    let currentErrors = {};

    if (!comments) {
      currentErrors.comments = "Comments are required"
    }

    props.setApprovalsForm({
      ...approvalsForm,
      errors: currentErrors
    })

    if (Object.keys(currentErrors).length === 0) {
      props.submitApprovalAction(action, requestId);
    }
  };

  return isPending ? (<VWLoading />) : (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        ></Message>
      )}
      <Form className="mb-3" name="formApprovalAction" onSubmit={handleSubmit}>
        <FormGroup>
          <Label>
            {action === "approved" ? "Approval Comments" : "Rejection Comments"}<span className="text-danger">*</span>
          </Label>
          <Input
            innerRef={textareaRef}
            autoFocus
            type="textarea"
            name="comments"
            placeholder="Enter comments"
            onChange={validateOnChange}
            value={comments || ""}
            invalid={approvalsForm && approvalsForm.errors && approvalsForm.errors.comments}
            rows={1}
            onKeyDown={handleKeyDown}
            style={{
              minHeight: "30px",
              resize: "none",
              overflow: "hidden",
            }}
          />
          <FormFeedback>{approvalsForm && approvalsForm.errors && approvalsForm.errors.comments}</FormFeedback>
        </FormGroup>
        <FormGroup>
          <Button
            type="submit"
            className='me-4'
            color="success"
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button
            color="danger"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  action: state.approvals.action,
  requestId: state.approvals.selectedId,
  approvalsForm: state.approvals.approvalsForm,
  errorMessage: state.approvals.errorMessage,
  isPending: state.approvals.isPending
});

const mapDispatchToProps = (dispatch) => ({
  setApprovalsForm: (approvalsForm) => dispatch(setApprovalsForm(approvalsForm)),
  submitApprovalAction: (action, requestId) => dispatch(submitApprovalAction(action, requestId)),
  clearSubmitApprovalActionError: () => dispatch(clearSubmitApprovalActionError())
});

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalAction);
